import state from "./state.js";
import actions from "./actions.js";
import reducer from "./reducer.js";
import createContext from "../createContext.js";
import { useContext } from "react";

const {
  Context: dashboardUIContext,
  Provider: DashboardUIProvider,
  actions: processedActions,
} = createContext(state, actions, reducer);

export const useDashboardUIContext = () => {
  return useContext(dashboardUIContext);
};

export const useDashboardUIActions = () => {
  return processedActions();
};

export default DashboardUIProvider;
